/**
 * Bibliothèque des fonds Karaté Phase 1 — 10 images dojo (WebP optimisé).
 * Originaux : C:\PROJETS\Karate\Image de fond\
 */

/** @typedef {{ id: string, src: string, file: string, theme?: string }} KarateBackground */

/** @type {KarateBackground[]} */
export const KARATE_BACKGROUNDS = [
  { id: "karate-bg-01", src: "/backgrounds/karate-bg-01.webp", file: "karate-bg-01.webp", theme: "dojo" },
  { id: "karate-bg-02", src: "/backgrounds/karate-bg-02.webp", file: "karate-bg-02.webp", theme: "dojo" },
  { id: "karate-bg-03", src: "/backgrounds/karate-bg-03.webp", file: "karate-bg-03.webp", theme: "dojo" },
  { id: "karate-bg-04", src: "/backgrounds/karate-bg-04.webp", file: "karate-bg-04.webp", theme: "dojo" },
  { id: "karate-bg-05", src: "/backgrounds/karate-bg-05.webp", file: "karate-bg-05.webp", theme: "dojo" },
  { id: "karate-bg-06", src: "/backgrounds/karate-bg-06.webp", file: "karate-bg-06.webp", theme: "dojo" },
  { id: "karate-bg-07", src: "/backgrounds/karate-bg-07.webp", file: "karate-bg-07.webp", theme: "enfants" },
  { id: "karate-bg-08", src: "/backgrounds/karate-bg-08.webp", file: "karate-bg-08.webp", theme: "femmes" },
  { id: "karate-bg-09", src: "/backgrounds/karate-bg-09.webp", file: "karate-bg-09.webp", theme: "familles" },
  { id: "karate-bg-10", src: "/backgrounds/karate-bg-10.webp", file: "karate-bg-10.webp", theme: "groupes-mixtes" },
];

/** Mapping documenté ancien nom source → fichier app (voir pilotage 008). */
export const SOURCE_FILE_MAPPING = [
  { source: "ChatGPT Image 30 juin 2026, 13 h 22 min 08 s (1).png", app: "karate-bg-01.webp" },
  { source: "ChatGPT Image 30 juin 2026, 13 h 22 min 08 s (2).png", app: "karate-bg-02.webp" },
  { source: "ChatGPT Image 30 juin 2026, 13 h 22 min 09 s (3).png", app: "karate-bg-03.webp" },
  { source: "ChatGPT Image 30 juin 2026, 13 h 22 min 09 s (4).png", app: "karate-bg-04.webp" },
  { source: "ChatGPT Image 30 juin 2026, 13 h 22 min 09 s (5).png", app: "karate-bg-05.webp" },
  { source: "ChatGPT Image 30 juin 2026, 13 h 22 min 10 s (6).png", app: "karate-bg-06.webp" },
  { source: "ChatGPT Image 1 juill. 2026, 13 h 11 min 53 s (1).png", app: "karate-bg-07.webp", theme: "enfants" },
  { source: "ChatGPT Image 1 juill. 2026, 13 h 11 min 54 s (2).png", app: "karate-bg-08.webp", theme: "femmes" },
  { source: "ChatGPT Image 1 juill. 2026, 13 h 11 min 55 s (3).png", app: "karate-bg-09.webp", theme: "familles" },
  { source: "ChatGPT Image 1 juill. 2026, 13 h 11 min 55 s (4).png", app: "karate-bg-10.webp", theme: "groupes mixtes" },
];

/** Routes principales où le fond peut changer à la navigation. */
const BACKGROUND_ROUTE_PREFIXES = [
  "/",
  "/dojos",
  "/instructeurs",
  "/etudiants",
  "/documents",
  "/protocoles",
  "/connexion",
  "/demande-compte",
  "/aide",
  "/accueil",
  "/formation",
  "/admin",
  "/sensei",
  "/sempai",
  "/mon-espace",
  "/parent",
];

/**
 * Clé de route pour déclencher un changement de fond (sans micro-changements).
 * @param {string} pathname
 */
export function getBackgroundRouteKey(pathname) {
  if (pathname === "/") return "/";
  if (pathname.startsWith("/accueil")) return "/accueil";
  if (pathname.startsWith("/admin")) return "/admin";
  if (pathname.startsWith("/sensei")) return "/sensei";
  if (pathname.startsWith("/sempai")) return "/sempai";
  if (pathname.startsWith("/parent")) return "/parent";
  if (pathname.startsWith("/mon-espace") || pathname.startsWith("/mon-dojo") || pathname.startsWith("/mon-sensei")) {
    return "/mon-espace";
  }
  if (pathname.startsWith("/connexion")) return "/connexion";
  if (pathname.startsWith("/demande-compte")) return "/demande-compte";
  if (pathname.startsWith("/dojos")) return "/dojos";
  if (pathname.startsWith("/instructeurs")) return "/instructeurs";
  if (pathname.startsWith("/etudiants")) return "/etudiants";
  if (pathname.startsWith("/documents")) return "/documents";
  if (pathname.startsWith("/protocoles")) return "/protocoles";
  if (pathname.startsWith("/aide")) return "/aide";
  if (pathname.startsWith("/formation")) return "/formation";
  return pathname.split("/").slice(0, 2).join("/") || "/";
}

export function isBackgroundEnabledRoute(pathname) {
  if (pathname === "/") return true;
  return BACKGROUND_ROUTE_PREFIXES.some(
    (p) => p !== "/" && (pathname === p || pathname.startsWith(`${p}/`)),
  );
}

/**
 * Choisit un fond aléatoire différent de excludeId (pas de répétition immédiate).
 * @param {string|null|undefined} excludeId
 * @returns {KarateBackground}
 */
export function pickRandomBackground(excludeId = null) {
  const pool =
    excludeId && KARATE_BACKGROUNDS.length > 1
      ? KARATE_BACKGROUNDS.filter((b) => b.id !== excludeId)
      : KARATE_BACKGROUNDS;
  const index = Math.floor(Math.random() * pool.length);
  return pool[index];
}
